import { getFormattedDate } from './getFormatedDate';
import { getInitials } from './getInitials';

export const getDocumentNumber = ({
  nameSurname,
  date,
}: { nameSurname: string; date: Date }) => {
  const initials = getInitials(nameSurname);
  const dateString = getFormattedDate(date);
  const randomNumbers = Math.floor(100000 + Math.random() * 900000);

  return `Nr.: ${initials}${dateString}-${randomNumbers}`;
};
